/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { camelCaseToRegularForm, capitalizeFirstLetter } from 'serenova-js-utils/strings';

import styled from 'styled-components';
import { SearchIconSVG,FilterSelect } from 'cx-ui-components';

const Input = styled.input`
  width: 100%;
`;
const SearchIcon = styled(SearchIconSVG)`
  position: relative;
  left: -17px;
  opacity: 0.4;
`;

export function amrStatusColumn(string, customString) {
  const normalizedString = customString ? camelCaseToRegularForm(customString) : camelCaseToRegularForm(string);
  const column = {
    id: string,
    Header: <span title={normalizedString}>Status</span>,
    accessor: string,
    Cell: ({ row }) => {
        return <span title={row[string]}>{row[string]}</span>; 
    },
    Filter: ({ filter, onChange }) => (
        <FilterSelect
        tableType="modal"
        onChange={(event) => onChange(event.target.value)}
        value={filter ? filter.value : 'all'}
        options={['all', 'In Progress', 'Completed', 'Cancelling','Canceled','Error']}
      />
    ),
    filterMethod: (filter, row) => {
        if (filter.value === 'all') {
          return true;
        }
        if (filter.value === 'In Progress') {
          return row[filter.id].toLowerCase() === 'inprogress';
        }
        if (filter.value === 'Completed') {
          return row[filter.id].replace(/[^\w\s]/gi, '').toLowerCase() === 'completed';
        }
        if (filter.value === 'Cancelling') {
          return row[filter.id].replace(/[^\w\s]/gi, '').toLowerCase() === 'cancelling';
        }
        if (filter.value === 'Canceled') {
          return row[filter.id].replace(/[^\w\s]/gi, '').toLowerCase() === 'canceled';
        }
        if (filter.value === 'Error') {
          return row[filter.id].replace(/[^\w\s]/gi, '').toLowerCase() === 'error';
        }
      },
  };
  column.Cell.propTypes = {
    row: PropTypes.any
  };
  column.Filter.propTypes = {
    filter: PropTypes.func,
    onChange: PropTypes.func
  };

  return column;
}
